import { render } from "./TwoImages.vue?vue&type=template&id=5632e4ef"
import script from "./TwoImages.vue?vue&type=script&lang=js"
export * from "./TwoImages.vue?vue&type=script&lang=js"

import "./TwoImages.vue?vue&type=style&index=0&id=5632e4ef&lang=scss"
script.render = render

export default script